import ExcelJS from "exceljs";
import QRCode from "qrcode";

const getQrValue = (studentId) =>
  `https://enoughphysics.com/scan-code/${studentId}/attendence`;

export const generateQrDataUrl = (value, size = 128) =>
  QRCode.toDataURL(value, {
    width: size,
    margin: 1,
    errorCorrectionLevel: "M",
  });

const sanitizeFilename = (filename) =>
  String(filename || "students-export").replace(/[<>:"/\\|?*]+/g, "-");

export const exportStudentsToExcel = async (
  students,
  filename = "students-export"
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Students");

  worksheet.columns = [
    { header: "Name", key: "name", width: 28 },
    { header: "Username", key: "user_name", width: 18 },
    { header: "Group", key: "group_name", width: 18 },
    { header: "Phone", key: "phone", width: 18 },
    { header: "Mother Phone", key: "mother_phone", width: 18 },
    { header: "QR", key: "qr", width: 14 },
  ];

  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true, color: { argb: "FF690000" } };
  headerRow.alignment = { horizontal: "center", vertical: "middle" };
  headerRow.height = 22;

  const QR_COLUMN_INDEX = 5;
  const QR_SIZE = 80;

  for (const student of students) {
    const row = worksheet.addRow({
      name: student.name || "",
      user_name: student.user_name || "",
      group_name: student.group?.name || "",
      phone: student.phone || "",
      mother_phone: student.mother_phone || "",
      qr: "",
    });

    row.height = 65;
    row.alignment = { vertical: "middle", horizontal: "center" };

    const qrDataUrl = await generateQrDataUrl(getQrValue(student.id), 128);

    if (qrDataUrl) {
      const imageId = workbook.addImage({
        base64: qrDataUrl,
        extension: "png",
      });

      worksheet.addImage(imageId, {
        tl: { col: QR_COLUMN_INDEX + 0.15, row: row.number - 0.85 },
        ext: { width: QR_SIZE, height: QR_SIZE },
      });
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${sanitizeFilename(filename)}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
};
